/* eslint-disable import/no-unresolved */
import { FormikProps } from "formik";
import { memo } from "react";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import Loan from "./Loan";
// import PaymentMethod from "./PaymentMethod";
import { LoanDetails } from "../../../../helpers/FormDetails/ProposalDetails/interfaces";
import AddRiders from "./AddRiders";
import PlanDetails from "./PlanDetails";
import PremiumDetails from "./PremiumDetails";
import PremiumFunding from "./PremiumFunding";
// import { RiderValidationSchema } from "src/helpers/FormDetails/LoanDetails"

interface Props {
  formik: FormikProps<LoanDetails>;
}

function LoanForm({ formik }: Props) {
  const recalculateError = useAppSelector((state) => state.common?.recalculateError);
  const isRiderActive = useAppSelector((state) => state.loanDetails?.isRiderSelectionLocked);

  return (
    <>
      <Loan formik={formik} />
      <PlanDetails formik={formik} />
      <PremiumDetails formik={formik} />
      {isRiderActive && <AddRiders formik={formik} />}
      <PremiumFunding formik={formik} />
      {recalculateError && <div className="mt-7 font-bold text-hotShot">{recalculateError}</div>}
      {/* <PaymentMethod formik={formik} /> */}
    </>
  );
}
export default memo(LoanForm);
